import React, { useState, useEffect } from "react";
import axiosConfig from "../../Service/axiosConfig";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import DataTable from "react-data-table-component";
import Masters from "../../Components/masters.json";
import { DeletePopupModal, PopupModal, FormParser } from "../../Components";
import { BiSearch } from "react-icons/bi";
import Modal from "react-bootstrap/Modal";
import { FaHandHoldingHeart } from "react-icons/fa";
import useDebouncedValue from "../../Utils/Debounce";
import AlertDeletePopupModal from "../../Components/PopupModal/AlertDeletePopupModal";
import { CMSNavbarComponent } from "../../Components/navbar";
const CreateHomepage = () => {
  const [Loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [modalTitle, setModalTitle] = useState("");
  const [LoadingButton, setLoadingButton] = useState();
  const [Data, SetData] = useState([]);
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [RowPerPage, setRowPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [formData, setFormData] = useState({});
  const [popupType, setpopupType] = useState("");
  const [RowId, SetRowId] = useState();
  const MastersModal = Masters.Createhomepage;
  const [deletePopupType, setDeletepopupType] = useState("");
  const [Error, SetError] = useState();
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [search, SetSearch] = useState({
    search: "",
  });
  const debouncedSearchTerm = useDebouncedValue(search.search, 500);
  const HandleSearch = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    console.log(name, value);
    SetSearch({ ...search, [name]: value });
  };
  const columns = [
    {
      name: "ID",
      cell: (row, index) => index + 1,
      reorder: true,
    },
    {
      name: "Home Page Name",
      selector: "home_page_name",
      cell: (row) => row.home_page_name,
      sortable: true,
      reorder: true,
    },
    {
      name: "Active",
      selector: "active",
      cell: (row) => (row.active ? "Active" : "InActive"),
      reorder: true,
    },
    {
      name: "ACTIONS",
      reorder: true,
      width : "240px",
      selector: (row) => {
        const HandleEdit = async () => {
          setShow(true);
          categoryedit(row.id);
          // handleShow(row.id);
          setModalTitle("Edit create homepage");
        };
        const DeleteAlert = () => {
          SetRowId(row.id);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };
        const HandleDelete = async (id) => {
          await axiosConfig
            .delete(`/cms/homepage_name/${id}/`)
            .then(() => {
              SetAlertDeletePopupType("error");
              setDeletepopupType("success");
              GetData();
            })
            .catch((error) => {
              setDeletepopupType("error");
              SetAlertDeletePopupType("error");
              console.log(error);
            });
        };
        const handleRevive = async () => {
          try {
            const response = await axiosConfig.post(
              `/cms/homepage_name/${row.id}/revive/`
            );
            setpopupType("success");
            setMessage("create homepage revived successfully");
            GetData();
          } catch (error) {
            console.log("Error While Reviving", error);
          }
        };
        const categoryedit = (id) => {
          axiosConfig
            .get(`/cms/homepage_name/${id}/`)
            .then((res) => {
              console.log(res.data, "edit");
              setFormData({
                ...res.data,
              });
              setShow(true);
              setMessage("Record Updated Successfully");
            })
            .catch((error) => {
              console.log(error);
            });
        };
        return (
          <>
            {!row.is_suspended ? (
              <div className="row">
                <div className="table-actions">
                  <button className="action-btn edit-btn" onClick={HandleEdit}>
                    <MdOutlineEdit /> Edit
                  </button>

                  <button className="action-btn delete-btn" onClick={DeleteAlert}>
                    <MdDeleteOutline /> Delete
                  </button>
                </div>
              </div>
            ) : (
              <>
                <FaHandHoldingHeart
                  className="dashboard-tabe-data-actions"
                  onClick={handleRevive}
                />
              </>
            )}
            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];
  const GetData = async () => {
    try {
      let response = await axiosConfig.get(
        `/cms/homepage_name/?page=${currentPage}&page_size=${RowPerPage}&search=${debouncedSearchTerm}`
      );
      console.log(response.data.results);
      SetData(response.data.results);
      setLoading(false);
      setTotalRows(response.data.count);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    GetData();
  }, [currentPage, RowPerPage, debouncedSearchTerm]);
  const formSubmit = async (FormData) => {
    console.log(FormData, "formdata");
    setLoadingButton(true);
    if (FormData.id) {
      await axiosConfig
        .patch(`/cms/homepage_name/${FormData.id}/`, FormData)
        .then((res) => {
          console.log(res);
          setpopupType("success");
          GetData();
          setShow(false);
        })
        .catch((error) => {
          console.log(error);
          let error_message = error.response.data;
          Object.values(error_message)[0] &&
            SetError(Object.values(error_message)[0]);
          setpopupType("error");
        });
      setLoadingButton(false);
    } else {
      await axiosConfig
        .post("/cms/homepage_name/", FormData)
        .then((res) => {
          console.log(res);
          setpopupType("success");
          GetData();
          setShow(false);
        })
        .catch((error) => {
          console.log(error);
          let error_message = error.response.data;
          Object.values(error_message)[0] &&
            SetError(Object.values(error_message)[0]);
          setpopupType(error);
        });
      setLoadingButton(false);
    }
  };
  const handleClose = () => {
    setShow(false);
    SetError("");
    setpopupType("");
    setMessage("");
    setLoadingButton(false);
  };
  const handleSort = (column, direction) => {
    console.log(column.selector, direction);
    axiosConfig
      .get(
        `/cms/homepage_name/?page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.selector : -column.selector
        }`
      )
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
    setCurrentPage(1);
  };
  const handleShow = () => {
    setShow(true);
    setFormData({
      home_page_name: "",
      active: "",
    });
    setModalTitle("Add Homepage Name");
  };
  const tableCustomStyles = {
    table: {
      style: {
        backgroundColor: "#fff",
        borderRadius: "18px",
        overflow: "hidden",
        border: "1px solid #e8e8e8",
        margin : "10px 10px"
      },
    },

    headRow: {
      style: {
        minHeight: "68px",
        borderBottom: "1px solid #ececec",
        backgroundColor: "#fff",
      },
    },

    headCells: {
      style: {
        fontSize: "11px",
        fontWeight: "500",
        color: "#6b7280",
        textTransform: "uppercase",
        letterSpacing: "1px",
        fontFamily: "Inter, sans-serif",
        paddingLeft: "18px",
        paddingRight: "18px",
      },
    },

    rows: {
      style: {
        minHeight: "78px",
        borderBottom: "1px solid #f1f1f1",
        fontSize: "13px",
        fontWeight: 500,
        fontFamily: "Inter, sans-serif",
      },
    },

    cells: {
      style: {
        paddingLeft: "18px",
        paddingRight: "18px",
        whiteSpace: "normal",
        lineHeight: "15px",
      },
    },

    pagination: {
      style: {
        borderTop: "1px solid #ececec",
        minHeight: "60px",
      },
    },
  };

  return (
    <>
      <div className="child-sidenav">
        <CMSNavbarComponent />
        <div className="childnav-content">
          <div className="d-flex align-items-center">
            <div className="col-4 input-cat-with-icon">
              <span className="icon-product">
                <BiSearch />
              </span>
              <input
                type="text"
                className="input-control"
                placeholder="Search"
                name="search"
                value={search.search}
                onChange={HandleSearch}
              />
            </div>
            <div className="cat-button">
              <div className="btn" onClick={handleShow}>
                + Add New
              </div>
            </div>
          </div>
          <div className="table-responsive marginTop">
            <DataTable
              columns={columns}
              data={Data}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationPerPage={RowPerPage}
              paginationDefaultPage={currentPage}
              onChangePage={(page) => setCurrentPage(page)}
              paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
              paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
              onChangeRowsPerPage={(RowsPerPageChange) =>
                setRowPerPage(RowsPerPageChange)
              }
              onSort={handleSort}
              fixedHeader
              subHeader
              customStyles={tableCustomStyles}
              progressPending={Loading}
              progressComponent={
                <div className="loader-container">
                  <img
                    src={require("../../Components/FormParser/images/loader2.gif")}
                    alt="Loading..."
                  />
                </div>
              }
            />
          </div>
          <Modal
            size="xl"
            show={show}
            onHide={handleClose}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <Modal.Header closeButton>
              <Modal.Title id="example-modal-sizes-title-lg">
                {modalTitle}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormParser
                modelObject={MastersModal}
                formData={formData}
                formSubmit={formSubmit}
                error={Error}
                buttonTitle="Save"
                LoadingButton={LoadingButton}
              />
            </Modal.Body>
          </Modal>
          {popupType !== "" && (
            <PopupModal
              setpopupType={setpopupType}
              popupType={popupType}
              Navigation=""
              Message={message}
              error={Error}
              setMessage={setMessage}
            />
          )}
          {deletePopupType !== "" && (
            <DeletePopupModal
              setDeletepopupType={setDeletepopupType}
              deletePopupType={deletePopupType}
            />
          )}
        </div>
      </div>
    </>
  );
};
export { CreateHomepage };
